import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {rxInit} from "./appSlice";

const loansAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.position - b.position
});

const initialState = {
  loans: loansAdapter.getInitialState(),

  editor: {
    show: false,
    mode: null
  }
};

export const loansSlice = createSlice({
  name: "loans",
  initialState,
  reducers: {
    showEditor: (state, action) => {
      state.editor.show = true;
      state.editor.mode = action.payload.mode;
      state.editor.loan = action.payload.loan;
    },

    hideEditor: state => {
      state.editor.show = false;
    },

    submitEditor: (state, action) => {
      loansAdapter.setMany(state.loans, action.payload);
    },

    updateLoans: (state, action) => {
      loansAdapter.setMany(state.loans, action.payload);
    }
  },
  extraReducers: builder => {
    builder.addCase(rxInit, (state, action) => {
      loansAdapter.setMany(state.loans, action.payload.loans);
    });
  }
});

export const {
  showEditor: rxShowLoanEditor,
  hideEditor: rxHideLoanEditor,
  submitEditor: rxSubmitLoanEditor,
  updateLoans: rxUpdateLoans,
} = loansSlice.actions;

export const {selectAll: selectAllLoans} = loansAdapter.getSelectors(state => state.loans.loans);

export const editorConfigSelector = state => state.loans.editor;

export default loansSlice.reducer;
